// extracted by mini-css-extract-plugin
export default {"wrap":"Center_wrap__jR8ql","inner":"Center_inner__hNzd2"};